import React, { Component } from 'react';
import NoticeboardAPICall from 'NOTICEBOARD/NoticeboardAPICall';
import { Base64 } from 'js-base64';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import Spinner from 'NOTICEBOARD/CommonResources/SpinnerLoader/Spinner';
import dummyNoticeImage from 'NOTICEBOARD/Components/NoticeList/Image/dummyNoticeImage.png';
import 'NOTICEBOARD/Components/NoticeList/noticelist.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from 'NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader';
import { Link } from 'react-router-dom';

class NoticeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES TO GET NOTICE LIST
            instituteDetailsFetching: false,
            instituteId: '',
            instituteName: '',
            instituteLogo: '',
            invalidUrl: false,
            noticeListFetching: false,
            noticeList: {},
            noticeSequence: [],
            pageIndex: 1,
            limit: 10,
            filterTitle: '',
            filterFromDate: '',
            filterToDate: '',
            filterToDateWarning: '',
            filterDayType: '',
            facultyListFetching: false,
            facultyList: {},
            filterPostedBy: [],
            academicYearFetching: false,
            academicYearList: {},
            filterAcademicYear: '',
            departmentFetching: false,
            departmentList: {},
            departmentCollapsed: true,
            filterDepartment: [],
            categoryFetching: false,
            categoryList: {},
            categoryCollapsed: true,
            filterCategory: [],

            // VARIABLES FOR SUCCESS MESSAGE
            successModal: false,
            successModalType: '',
            successMessage: ''
        };
    }

    componentDidMount() {
        // METHOD CALLED TO GET INSTITUTE DETAILS BY URL
        this.apiCallToGetInstituteDetails();
    }

    // API CALL METHOD TO GET INSTITUTE DETAILS
    apiCallToGetInstituteDetails = async() => {
        this.setState({
            instituteDetailsFetching: true
        });

        let requestData = {
            "url": this.props.match.params.instituteUrl,
        };

        let jsonResponse = await NoticeboardAPICall.makeAPICall(
            'getInstituteDataByURL',
            requestData,
            '/api/generic_api.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetNoticeList();
            }, 1000);
        } else {
            if(jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    instituteId: apiResult.InstituteId,
                    instituteName: apiResult.InstituteName,
                    instituteLogo: apiResult.InstituteLogo,
                    instituteDetailsFetching: false
                }, () => {
                    // METHOD CALLED TO GET NOTICE LIST
                    this.apiCallToGetNoticeList();

                    // METHOD CALLED TO GET ACADEMIC YEAR LIST
                    this.apiCallToGetAcademicYearList();
                    
                    // METHOD CALLED TO GET DEPARTMENT LIST
                    this.apiCallToGetDepartmentList();
                    
                    // METHOD CALLED TO GET CATEGORY LIST
                    this.apiCallToGetCategoryList();
                });                
            }else {
                this.setState({
                    invalidUrl: true,
                    instituteDetailsFetching: false
                });
            }
        }
    }

    // API CALL METHOD TO GET ACADEMIC YEAR LIST
    apiCallToGetAcademicYearList = async () => {
        this.setState({
            academicYearFetching: true
        });

        let requestData = {
            "iid": this.state.instituteId,
        };

        let jsonResponse = await NoticeboardAPICall.makeAPICall(
            'GetAcademicYearListObject',
            requestData,
            '/api/admission/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                
                if(Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(yearId => {
                        apiResult[yearId]['yearId'] = yearId;
                    });
                }

                this.setState({
                    academicYearList: apiResult,
                    academicYearFetching: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting academic year list. Please try again later.',
                    academicYearFetching: false
                });
            }
        }
    }

    // API CALL METHOD TO GET DEPARTMENT LIST
    apiCallToGetDepartmentList = async () => {
        this.setState({
            departmentFetching: true
        });

        let requestData = {
            "iid": this.state.instituteId,
            "sidArray": []
        };

        let jsonResponse = await NoticeboardAPICall.makeAPICall(
            'GetInstituteStreamsObject',
            requestData,
            '/api/admission/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetDepartmentList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                
                if(Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(departmentId => {
                        apiResult[departmentId]['departmentId'] = departmentId;
                    });
                }

                this.setState({
                    departmentList: apiResult,
                    departmentFetching: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting department list. Please try again later.',
                    departmentFetching: false
                });
            }
        }
    }

    // API CALL METHOD TO GET CATEGORY LIST
    apiCallToGetCategoryList = async () => {
        this.setState({
            categoryFetching: true
        });

        let requestData = {
            "iid": this.state.instituteId
        };

        let jsonResponse = await NoticeboardAPICall.makeAPICall(
            'GetNoticeBoardCategoryList',
            requestData,
            '/api/notice/publicNotice.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetCategoryList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                
                if(Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(categoryId => {
                        apiResult[categoryId]['categoryId'] = categoryId;
                    });
                }
                
                this.setState({
                    categoryList: apiResult,
                    categoryFetching: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting category list. Please try again later.',
                    categoryFetching: false
                });
            }
        }
    }

    // API CALL METHOD TO GET NOTICE LIST
    apiCallToGetNoticeList = async() => {
        this.setState({
            noticeListFetching: true
        });

        let requestData = {
            "institute_id": this.state.instituteId,
            "page_index": '',
            "limit": '',
            "filter_title": this.state.filterTitle,
            "filter_from_date": this.state.filterFromDate,
            "filter_to_date": this.state.filterToDate,
            "filter_day_type": '',
            "filter_posted_by_id_array": this.state.filterPostedBy,
            "academicYearId": this.state.filterAcademicYear,
            "sidArray": this.state.filterDepartment,
            "categoryIdArray": this.state.filterCategory
        };

        let jsonResponse = await NoticeboardAPICall.makeAPICall(
            'getPublicNoticeList',
            requestData,
            '/api/notice/publicNotice.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetNoticeList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    noticeList: apiResult,
                    noticeSequence: jsonResponse.APIResult.sequenceIdArray,
                    noticeListFetching: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting notice list. Please try again later.',
                    noticeListFetching: false
                });
            }
        }
    }

    // METHOD TO UPDATE DEPARTMENT VISIBILITY
    updateDepartmentVisibility = () => {
        this.setState({
            departmentCollapsed: !this.state.departmentCollapsed
        });
    }

    // METHOD TO UPDATE CATEGORY VISIBILITY
    updateCategoryVisibility = () => {
        this.setState({
            categoryCollapsed: !this.state.categoryCollapsed
        });
    }

    // METHOD TO SELECT FILTER DEPARTMENT
    selectFilterDepartment = (departmentId) => {
        let filterDepartment = this.state.filterDepartment;

        if(filterDepartment.includes(departmentId)) {
            filterDepartment = filterDepartment.filter(id => id != departmentId);
        }else {
            filterDepartment.push(departmentId);
        }

        this.setState({
            filterDepartment
        });
    }

    // METHOD TO SELECT FILTER CATEGORY
    selectFilterCategory = (categoryId) => {
        let filterCategory = this.state.filterCategory;

        if(filterCategory.includes(categoryId)) {
            filterCategory = filterCategory.filter(id => id != categoryId);
        }else {
            filterCategory.push(categoryId);
        }

        this.setState({
            filterCategory
        });
    }

    // METHOD TO APPLY FILTER
    applyFilter = () => {
        let validData = true;

        if(this.state.filterFromDate.length > 0 && this.state.filterToDate.length < 1) {
            this.setState({
                filterToDateWarning: 'Please select to date to get details.'
            });
            validData = false;
        }

        if(validData) {
            this.setState({
                filterApplied: true
            }, () => {
                // METHOD CALLED TO GET NOTICE LIST
                this.apiCallToGetNoticeList();
            });
        }
    }

    // METHOD TO CLEAR FILTER
    clearFilter = () => {
        this.setState({
            filterTitle: '',
            filterFromDate: '',
            filterToDate: '',
            filterAcademicYear: '',
            filterDepartment: [],
            filterCategory: [],
            filterApplied: false
        }, () => {
            // METHOD CALLED TO GET NOTICE LIST
            this.apiCallToGetNoticeList();
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    render() {
        return (
            <>
                <div className="noticeList-container">
                    {
                        this.state.instituteDetailsFetching ?
                            <Spinner />
                        :
                            this.state.invalidUrl ?
                                <div className="invalid-url-message">
                                    <p className="invalidUrl-message">Invalid URL.</p>
                                </div>
                            :
                                <div className="noticeList-details">
                                    <div className="institute-details">
                                        <img alt="logo" src={this.state.instituteLogo} width={40} height={40} />
                                        <h4 style={{ marginLeft: 10 }}>{this.state.instituteName}</h4>
                                    </div>
                                    <div className="noticeList-wrapper">
                                        <div className="filter-container">
                                            <div className="filter-details">
                                                <div className="searchByTitle">
                                                    <input
                                                        type="text"
                                                        className="form-control filterInput"
                                                        placeholder="Search by title..."
                                                        value={this.state.filterTitle}
                                                        onChange={(e) => this.setState({ filterTitle: e.target.value })}
                                                    />
                                                </div>
                                                <div className="postedOn" style={{ marginTop: 10 }}>
                                                    <label style={{ marginBottom: 0, fontSize: 12, fontWeight: 'bold' }}>Posted on Date Range</label>
                                                    <div className="postedOnRange">    
                                                        <div className="fromDate">
                                                            <input
                                                                type="date"
                                                                className="form-control filterInput"
                                                                value={this.state.filterFromDate}
                                                                onChange={(e) => e.target.value.length < 1 ? this.setState({ filterFromDate: e.target.value, filterToDate: '', filterToDateWarning: '' }) : this.setState({ filterFromDate: e.target.value })}
                                                            />
                                                        </div>
                                                        <div className="toDate">
                                                            <input
                                                                type="date"
                                                                className="form-control filterInput"
                                                                value={this.state.filterToDate}
                                                                disabled={this.state.filterFromDate == ''}
                                                                min={this.state.filterFromDate}
                                                                onChange={(e) => e.target.value.length < 1 ? this.setState({ filterToDate: e.target.value, filterToDateWarning: 'Please select to date to get the details.' }) : this.setState({ filterToDate: e.target.value, filterToDateWarning: '' })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <p style={{ fontSize: 12 }} className="text-danger">{this.state.filterToDateWarning}</p>
                                                </div>
                                                <div className="academicYearSelection" style={{ marginTop: 10 }}>
                                                    <label style={{ marginBottom: 0, fontSize: 12, fontWeight: 'bold' }}>Academic Year</label>
                                                    <select
                                                        className="form-control filterInput"
                                                        value={this.state.filterAcademicYear}
                                                        onChange={(e) => this.setState({ filterAcademicYear: e.target.value })}
                                                    >
                                                        <option value="">Select Academic Year</option>
                                                        {
                                                            Object.keys(this.state.academicYearList).length > 0 &&
                                                                Object.values(this.state.academicYearList).map(year => {
                                                                    return(
                                                                        <option value={year.yearId} key={year.yearId}>{year.year_text}</option>
                                                                    );
                                                                })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="departmentSelection" style={{ marginTop: 10 }}>
                                                    <div className="departmentHeader" onClick={() => this.updateDepartmentVisibility()}>
                                                        <label style={{ marginBottom: 0, fontSize: 12, fontWeight: 'bold' }}>Department</label>
                                                        <FontAwesomeIcon icon={['fas', this.state.departmentCollapsed ? 'angle-up' : 'angle-down']} />
                                                    </div>
                                                    {
                                                        this.state.departmentCollapsed &&
                                                            <div className="departmentList">
                                                                {
                                                                    this.state.departmentFetching ?
                                                                        <ButtonLoader />
                                                                    :
                                                                        Object.keys(this.state.departmentList).length > 0 ?
                                                                            Object.values(this.state.departmentList).map(department => {
                                                                                return(
                                                                                    <div className="department-data" key={department.departmentId}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={this.state.filterDepartment.includes(department.departmentId)}
                                                                                            onChange={() => this.selectFilterDepartment(department.departmentId)}
                                                                                            style={{ marginRight: 5 }}
                                                                                        />
                                                                                        <span style={{ fontSize: 12 }}>{department.stream_name}</span>
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        :
                                                                            <p style={{ fontSize: 12, color: '#818181' }}>No department details found.</p>
                                                                }
                                                            </div>
                                                    }
                                                </div>
                                                <div className="categorySelection" style={{ marginTop: 10, width: '100%' }}>
                                                    <div className="categoryHeader" onClick={() => this.updateCategoryVisibility()}>
                                                        <label style={{ marginBottom: 0, fontSize: 12, fontWeight: 'bold' }}>Category</label>
                                                        <FontAwesomeIcon icon={['fas', this.state.categoryCollapsed ? 'angle-up' : 'angle-down']} />
                                                    </div>
                                                    {
                                                        this.state.categoryCollapsed &&
                                                            <div className="categoryList" style={{ width: '100%' }}>
                                                                {
                                                                    this.state.categoryFetching ?
                                                                        <ButtonLoader />
                                                                    :
                                                                        Object.keys(this.state.categoryList).length > 0 ?
                                                                            Object.values(this.state.categoryList).map(category => {
                                                                                return(
                                                                                    <div className="category-data" key={category.categoryId} style={{ width: '100%' }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={this.state.filterCategory.includes(category.categoryId)}
                                                                                            onChange={() => this.selectFilterCategory(category.categoryId)}
                                                                                            style={{ marginRight: 5 }}
                                                                                        />
                                                                                        <p title={category.title} style={{ fontSize: 12, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{category.title}</p>
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        :
                                                                            <p style={{ fontSize: 12, color: '#818181' }}>No category details found.</p>
                                                                }
                                                            </div>
                                                    }
                                                </div>
                                                <div className="filter-buttons">
                                                    <button className="btn primary-button filter-button" onClick={() => this.applyFilter()}>Apply</button>
                                                    <button className="btn outline-button filter-button" onClick={() => this.clearFilter()}>Clear</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="noticeList">
                                            <div className="notice-list">
                                                {
                                                    this.state.noticeListFetching ?
                                                        <Spinner />
                                                    :
                                                        Object.keys(this.state.noticeList).length > 0 ?
                                                            this.state.noticeSequence.map(noticeId => {
                                                                let notice = this.state.noticeList[noticeId];
                                                                let noticeAttachments = notice.attachment == '' ? [] : notice.attachment.split(',');
                                                                return(
                                                                    <div className="noticeCard">
                                                                        <div className="noticeDateTime">
                                                                            <div className="noticeDate">
                                                                                <p style={{ fontSize: 16 }}>{parseInt((notice.formattedNoticeDate.split(',')[0]).split(' ')[0])}</p>
                                                                                <p style={{ fontSize: 14 }}>{(notice.formattedNoticeDate.split(',')[0]).split(' ')[1]}</p>
                                                                            </div>
                                                                            <div className="postedBy-updated">
                                                                                By {notice.addedBy}
                                                                            </div>
                                                                        </div>
                                                                        <div className="noticeAttachments">
                                                                            {
                                                                                noticeAttachments.length < 1 ?
                                                                                    <div className="dummyImage-container">
                                                                                        <img src={dummyNoticeImage} height='100%' width='100%' />
                                                                                    </div>
                                                                                :
                                                                                    noticeAttachments.length < 3 ?
                                                                                        <div className="noticeImage-container">
                                                                                            {
                                                                                                noticeAttachments[0].substring(noticeAttachments[0].lastIndexOf('.') + 1) == 'pdf' ?
                                                                                                    <FontAwesomeIcon className="pdfIcon" icon={ ['fas', 'file-pdf'] } />
                                                                                                :
                                                                                                    <img src={notice.attachmentPath + noticeAttachments[0]} height='100%' width='100%' style={{ borderRadius: 5 }} />
                                                                                            }
                                                                                        </div>
                                                                                    :
                                                                                        <div className="noticeAttachmentContainer">
                                                                                            <div className="singleImage-container">
                                                                                                {
                                                                                                    noticeAttachments[0].substring(noticeAttachments[0].lastIndexOf('.') + 1) == 'pdf' ?
                                                                                                        <FontAwesomeIcon className="pdfIcon" icon={ ['fas', 'file-pdf'] } />
                                                                                                    :
                                                                                                        <img src={notice.attachmentPath + noticeAttachments[0]} height='100%' width='100%' style={{ borderRadius: 5 }} />
                                                                                                }
                                                                                            </div>
                                                                                            <div className='otherNoticeAttachments'>
                                                                                                <div className="smallAttachment-container">
                                                                                                    {
                                                                                                        noticeAttachments[1].substring(noticeAttachments[1].lastIndexOf('.') + 1) == 'pdf' ?
                                                                                                            <FontAwesomeIcon className="pdfIcon" icon={ ['fas', 'file-pdf'] } />
                                                                                                        :
                                                                                                            <img src={notice.attachmentPath + noticeAttachments[1]} height='100%' width='100%' style={{ borderRadius: 5 }} />
                                                                                                    }
                                                                                                </div>
                                                                                                <div className="smallAttachment-container">
                                                                                                    {
                                                                                                        noticeAttachments[2].substring(noticeAttachments[2].lastIndexOf('.') + 1) == 'pdf' ?
                                                                                                            <FontAwesomeIcon className="pdfIcon" icon={ ['fas', 'file-pdf'] } />
                                                                                                        :
                                                                                                            <img src={notice.attachmentPath + noticeAttachments[2]} height='100%' width='100%' style={{ borderRadius: 5 }} />
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                            }
                                                                        </div>
                                                                        <div className="noticeTitle-details">
                                                                            <Link to={`/${this.props.match.params.instituteUrl}/${Base64.encode(notice.noticeId)}`}><p className="notice-title" title={notice.title}>{notice.title.length > 200 ? notice.title.substring(0, 200) + '...' : notice.title}</p></Link>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        :
                                                            this.state.filterApplied ?
                                                                <p>No notices found as per applied filter.</p>
                                                            :
                                                                <p>No notices found.</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    }
                </div>
                {
                    this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal} 
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal} 
                        />
                }
            </>
        );
    }
}

export default NoticeList;